export default __webpack_public_path__ + "static/media/a6-print-label-1-page.f2dcfa0f.svg";